<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import { translation } from '$lib/locale/locale';
  import { CartItem, CartItemFrom } from '$lib/models/cart-item';
  import type { Tag } from '$lib/models/tag';
  import type { User } from '$lib/models/user';
  import { AssetType } from '$lib/utils/asset';
  import { canDownloadType } from '$lib/utils/download';
  import { slide } from 'svelte/transition';
  import { startTrialFlow } from '../free-trial/trial-flow';

  const { langHref,  locale } = translation();

  export let category: Tag | null;
  export let type: AssetType;
  export let user: User | null | void;

  $: cartFrom =
    type == AssetType.SFX
      ? CartItemFrom.SearchHeroSfx
      : type == AssetType.Intro
      ? CartItemFrom.SearchHeroIntro
      : CartItemFrom.SearchHeroTrack;
</script>

<div class="makeup" transition:slide>
  <div class="container-ld">
    {#if category?.description}
      {@html category.description}
    {:else if type == AssetType.Track}
      <h1>{m['search.tracks-title']()}</h1>
      <h2>{m['search.tracks-home-subtitle']()}</h2>
    {:else if type == AssetType.SFX}
      <h1>{m['search.sfx-title']()}</h1>
      <h2>{m['search.sfx-home-subtitle']()}</h2>
    {:else if type == AssetType.Intro}
      <h1>{m['search.intros-title']()}</h1>
      <h2>{m['search.intros-home-subtitle']()}</h2>
    {/if}

    {#if !canDownloadType(type, user)}
      <div class="cta-group">
        <button class="btn-pink-big main-button" on:click={() => startTrialFlow(cartFrom)}>{m['home.cta-trial']()}</button>
        <p class="button-note">
          {m['home.no-copyright']()}
        </p>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../../variables.scss';

  $opacity: 0.12;
  .makeup {
    background-color: #FCFCFD;
    // animation: gradient 30s infinite;
    // background-size: 200% 200%;
  //   background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.6) 0%, transparent 20%),
  //     linear-gradient(to top, white 0%, transparent 10%),
  //     radial-gradient(circle at 17% 15%, rgba(252, 69, 110, $opacity) 0%, transparent 20%, transparent 100%),
  //     radial-gradient(circle at 32% 45%, rgba(252, 69, 190, $opacity) 0%, transparent 20%, transparent 100%),
  //     radial-gradient(circle at 48% 25%, rgba(226, 69, 252, $opacity) 0%, transparent 20%, transparent 100%),
  //     radial-gradient(circle at 65% 10%, rgba(252, 69, 110, $opacity) 0%, transparent 20%, transparent 100%);
  }

  // @keyframes gradient {
  //   0% {
  //     background-position: 0% 50%;
  //   }
  //   10% {
  //     background-position: 100% 10%;
  //   }
  //   20% {
  //     background-position: 30% 80%;
  //   }
  //   30% {
  //     background-position: 40% 0%;
  //   }
  //   40% {
  //     background-position: 100% 0%;
  //   }
  //   50% {
  //     background-position: 100% 50%;
  //   }
  //   100% {
  //     background-position: 0% 50%;
  //   }
  // }

  .container-ld :global(h1) {
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    margin-top: 0;
    padding-top: 45px;
  }

  .container-ld :global(h2) {
    font-size: 16px;
    line-height: 24px;
    margin-top: 20px;
    padding-bottom: 48px;
    margin-bottom: 0;
    font-weight: 400;
    color: $black-coral;
    max-width: 840px;
  }

  .cta-group {
    padding-bottom: 48px;
    display: flex;
    align-items: center;
    .button-note {
      display: flex;
      flex-direction: column;
      padding: 0;
      margin: 0;
      margin-left: 16px;
    }

    .btn-pink-big {
      font-size: 18px;
      padding: 12px 36px;
    }
  }

  @media (max-width: $svelte-mobile) {
    .container-ld :global(h1) {
      font-size: 20px;
      font-weight: 500;
      line-height: 32px;
      padding-top: 18px;
    }

    .container-ld :global(h2) {
      font-size: 14px;
      line-height: 20px;
      margin-top: 12px;
      padding-bottom: 24px;
    }

    .cta-group {
      margin-top: -5px;
      flex-direction: column;
      align-items: start;
      padding-bottom: 20px;
      .button-note {
        margin-top: 8px;
        margin-left: 0;
      }
      .btn-pink-big {
        font-size: 14px;
        padding: 8px 20px;
      }
    }
  }
</style>
